import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5856230f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "g-card order-form" }
const _hoisted_2 = {
  bindtap: "toggleRemark",
  class: "form-header"
}
const _hoisted_3 = { class: "form-subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, " 点击填写订单备注内容 ", -1))
const _hoisted_5 = { class: "remark-input" }
const _hoisted_6 = { class: "cargo-remark" }
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, { icon: "icon_remark" }),
        _createTextVNode(" 订单备注 "),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QUICK_REMARK, (item) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "g-checkbox",
            key: item.value
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: item.value,
              name: "selectRemark",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.selectRemark) = $event))
            }, null, 8, _hoisted_7), [
              [_vModelCheckbox, _ctx.form.selectRemark]
            ]),
            _createTextVNode(" " + _toDisplayString(item.desc), 1)
          ]))
        }), 128))
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "adjust-position": "{{true}}",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.remark) = $event)),
        placeholder: "输入您的需求，我们会竭力的为您处理。",
        "confirm-type": "return",
        maxlength: "255"
      }, null, 512), [
        [_vModelText, _ctx.form.remark]
      ])
    ])
  ]))
}